import { Flex } from "grid-styled";

export const Container = Flex.extend<{ maxwidth?: number }>`
  margin: 0 auto;
  max-width: ${({ maxwidth }) => (maxwidth ? maxwidth : 940)}px;
`;



// WEBPACK FOOTER //
// ./src/components/Container/Container.ts